export enum ApplicationPlan {
  ForYou = 'ForYou',
  ForYouAndOther = 'ForYouAndOther',
}
